import { apiCallBegan } from '../../actions/afterAuth';
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { APIErrorResp } from '../index.types';
import { IOnlineUserResp, IDetailsState } from './index.types';

const initialState: IDetailsState = {
  loading: false,
  users: [],
  receivedMessage: false,
  messageContent: undefined
};

const onlineUsersSlice = createSlice({
  name: 'online-users',
  initialState,
  reducers: {
    request: state => {
      state.loading = true;
    },
    setOnlineUsers: (state, { payload }: { payload: IOnlineUserResp[] }) => {
      state.loading = false;
      if(payload.length>0){
      state.users = payload;
      }
  
      
    },
    setReceivedConsentMessage:(state, { payload }: { payload: { From: string; Body: string; } })=>{
     
      state.receivedMessage = true;
      state.messageContent = payload;
    },
    clearRescivedMessage:state=>{
      state.receivedMessage = false;
      state.messageContent = undefined;
    },
    resetOnlineUsers: state => {
      state = initialState;
    },
    fail: (state, { payload: data }: { payload: APIErrorResp }) => {
      state.loading = false;
      state.users = [];
    },
  },
});

export const { fail, request, setOnlineUsers, resetOnlineUsers, setReceivedConsentMessage ,clearRescivedMessage} = onlineUsersSlice.actions;

export const onlineUsersSliceValue = (state: RootState) => state.onlineUsers;

export default onlineUsersSlice.reducer;
